export const navigationItems = [
  { title: 'Features', link: 'features' },
  { title: 'About', link: 'about' },
  { title: "FAQ's", link: 'faqs' },
];

// In a separate file, let's say featuresData.js
export const features = [{
    title: 'Real-time collaboration',
    description: 'Edit code and see updates while collaborating with other users in real-time.',
    image: require('../images/features/feature_1.png'),
  },
  {
    title: 'Organize your files',
    description: 'Access to your Dashboard to organize & keep track of your files.',
    image: require('../images/features/feature_2.png'),
  },
  {
    title: 'Syntax highlighting in your preferred language',
    description: 'Choose among 120+ programming languages to adapt your file syntax.',
    image: require('../images/features/feature_3.png'),
  },
  {
    title: 'Share the link to invite people',
    description: 'Share the file link with your colleague to start editing it together.',
    image: require('../images/features/feature_4.png'),
  },
];


export const featuresData = [{
    heading: "Empowering Every File with a Unique Identity",
    para: "Automated file sharing made easy. Dynamic Link Generation in our 'Featured' card creates unique links for secure and seamless collaboration.",
  },
  {
    heading: "Advanced Private Sharing for Ultimate Data Protection",
    para: "Safeguard your data with our advanced private sharing feature. Experience ultimate protection and peace of mind while sharing sensitive information securely.",
  },
  {
    heading: "Safeguarded Link Access with Uneditable Sharing",
    para: "Our uneditable sharing feature ensures unparalleled data protection, granting access to authorized users for safeguarding privacy and sensitive information.",
  },
];

export const faqData = [
    {
      question: "How can I share my text on your platform?",
      answer:
        "Sharing your text is simple! Just sign up for an account, log in, and click on the 'Share' button. You can paste your text or type directly into the editor. Once you're done, click 'Submit,' and your text will be shared with the community.",
    },
    {
      question: "Is my shared content visible to everyone or can I control its privacy?",
      answer:
        "We value your privacy. You have complete control over the visibility of your shared content. You can choose to make it public for everyone to see or keep it private and share it with select individuals or groups.",
    },
    {
      question: "Can I collaborate with others on shared text documents?",
      answer:
        "Absolutely! Collaboration is at the heart of our platform. You can invite others to collaborate on your shared text documents, fostering creativity and teamwork in real-time.",
    },
    {
      question: "What types of text formats does your platform support?",
      answer:
        "Our platform supports a wide range of text formats, including plain text, rich text (RTF), Markdown, and more. You can write in your preferred format and share your ideas seamlessly.",
    },
    {
      question: "Is there a word limit for each text submission?",
      answer:
        "We encourage creativity without constraints. There's no strict word limit for text submissions, allowing you to express yourself fully in your writing.",
    },
    {
      question: "How do I discover and connect with other writers and readers on the website?",
      answer:
        "Connecting with fellow writers and readers is easy! You can explore our user profiles, engage in discussions on the community forum, and even follow your favorite authors. Building meaningful connections has never been more accessible.",
    },
  ];